"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const luxon_1 = require("luxon");
const belfast_entity_1 = require("@kaizenplatform/belfast-entity");
class ApiFileReference extends belfast_entity_1.FileReference {
    static fromJSON(value) {
        const { id, mimetype, size, originalName, url, createdAt: _createdAt } = Object.assign({}, value);
        if (typeof id !== 'string')
            throw new TypeError('.id must be a string');
        if (typeof mimetype !== 'string')
            throw new TypeError('.mimetype must be a string');
        if (!Number.isSafeInteger(size))
            throw new TypeError('.size must be an integer');
        if (typeof originalName !== 'string')
            throw new TypeError('.originalName must be a string');
        if (typeof url !== 'string')
            throw new TypeError('.url must be a string');
        const createdAt = luxon_1.DateTime.fromISO(_createdAt);
        if (!createdAt.isValid)
            throw new TypeError('.createdAt must be a valid ISO8601 date string');
        return new ApiFileReference({ id, mimetype, size, originalName, createdAt, url: `${url}?download=true` });
    }
    constructor({ id, mimetype, size, originalName, createdAt, url, }) {
        super({ id, mimetype, size, originalName, createdAt, url });
    }
}
exports.default = ApiFileReference;
